import { Navigate, Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ContentList from './pages/ContentList';
import ContentEdit from './pages/ContentEdit';
import MediaLibrary from './pages/MediaLibrary';
import Settings from './pages/Settings';
import NavigationEdit from './pages/NavigationEdit';
import ContentExplorer from './pages/ContentExplorer';
import ThemeSelector from './pages/ThemeSelector';
import ComponentCatalog from './pages/ComponentCatalog';
import ContentPolicies from './pages/ContentPolicies';
import PagePreview from './pages/PagePreview';
import Users from './pages/Users';
import PublishStatus from './pages/PublishStatus';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function ProtectedPage({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedPage><Dashboard /></ProtectedPage>} />
        <Route path="/content" element={<ProtectedPage><ContentList /></ProtectedPage>} />
        <Route path="/content/new" element={<ProtectedPage><ContentEdit /></ProtectedPage>} />
        <Route path="/content/:contentId" element={<ProtectedPage><ContentEdit /></ProtectedPage>} />
        <Route path="/content/:contentId/preview" element={<ProtectedPage><PagePreview /></ProtectedPage>} />
        <Route path="/navigation" element={<ProtectedPage><NavigationEdit /></ProtectedPage>} />
        <Route path="/themes" element={<ProtectedPage><ThemeSelector /></ProtectedPage>} />
        <Route path="/components" element={<ProtectedPage><ComponentCatalog /></ProtectedPage>} />
        <Route path="/policies" element={<ProtectedPage><ContentPolicies /></ProtectedPage>} />
        <Route path="/explorer" element={<ProtectedPage><ContentExplorer /></ProtectedPage>} />
        <Route path="/media" element={<ProtectedPage><MediaLibrary /></ProtectedPage>} />
        <Route path="/settings" element={<ProtectedPage><Settings /></ProtectedPage>} />
        <Route path="/users" element={<ProtectedPage><Users /></ProtectedPage>} />
        <Route path="/publish" element={<ProtectedPage><PublishStatus /></ProtectedPage>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ThemeProvider>
  );
}